module.exports = __webpack_public_path__ + "static/media/clear_night.14a75ed3.svg";